import { ModelSagres } from "../../model-sagres"

export class PrazoDeVencimentoLRFCI extends ModelSagres {
    IdPeriodorelatorio: number
    IdTiporelatorio: number
    PeriodoPrestacao: string
    PeriodoRelatorio: string
    DataVencimentoOriginal: Date
    DataVencimento: Date
    Exercicio: number
    IdVencimentoSagresLrfci?: number
    Justificativa: string


    /**
     * Trata os dados recebidos pela API. Estão vindo com estas inconsistências no momento. Não execute em outras situações
     * @since 20220614
     */
    tratarDadosDaAPI(): void {
        if (this.IdPeriodorelatorio) {
            this.PeriodoRelatorio = String(this.IdPeriodorelatorio)
        }
        if (this.DataVencimento) {
            this.DataVencimento = new Date(this.DataVencimento)
        }
        if (this.DataVencimentoOriginal) {
            this.DataVencimentoOriginal = new Date(this.DataVencimentoOriginal)
        }
    }
}